<div class="modal-header border-bottom-0 d-flex justify-content-between align-items-flex-start py-3 px-4">
  <!-- Header Content -->
  <div class="modal-title-wrapper">
    <h5 class="modal-title" *ngIf="!headerTemplate && headerContent">
      {{ headerContent }}
    </h5>
    <p class="modal-description mb-0 text-muted d-block" *ngIf="description">
      {{ description }}
    </p>
    <ng-container *ngIf="headerTemplate">
      <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
    </ng-container>
  </div>

  <!-- Close Button -->
  <button
    *ngIf="config.closeButton"
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="onClose()"
  ></button>
</div>

<!-- Body Content -->
<div class="modal-body">
  <!-- Template or String Content -->
  <ng-container *ngIf="bodyTemplate">
    <ng-container *ngTemplateOutlet="bodyTemplate"></ng-container>
  </ng-container>

  <p *ngIf="!bodyTemplate && bodyContent" class="mb-0">
    {{ bodyContent }}
  </p>

  <!-- Default message if no content -->
  <p *ngIf="!bodyTemplate && !bodyContent" class="text-muted mb-0">
    No content provided.
  </p>
</div>

<!-- Footer Content -->
<div class="modal-footer" *ngIf="footerTemplate || footerContent || footerButtons.length > 0">
  <!-- Custom Footer Template -->
  <ng-container *ngIf="footerTemplate">
    <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
  </ng-container>

  <!-- Footer Text Content -->
  <p *ngIf="!footerTemplate && footerContent && footerButtons.length === 0" class="mb-0">
    {{ footerContent }}
  </p>

  <!-- Footer Buttons -->
  <div *ngIf="footerButtons.length > 0" class="footer-buttons-container form-actions d-flex gap-3">
    <button
      *ngFor="let button of footerButtons"
      type="button"
      class="btn"
      [ngClass]="button.cssClass || 'btn-secondary'"
      (click)="onButtonClick(button)"
    >
      {{ button.label }}
    </button>
  </div>
</div>
